import { ChangeDetectionStrategy, Component, OnChanges, input } from '@angular/core';
import { Observable } from 'rxjs';

import { DotCmsFacade } from '../../../facades/dot-cms.facade';
import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';

@Component({
  selector: 'custom-dotcms-faq-widget',
  templateUrl: './dotcms-faq-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotcmsFaqWidgetComponent implements OnChanges {
  readonly identifier = input<string>(undefined);
  contentlet$: Observable<CustomDotCmsContentlet>;

  constructor(private dotCmsFacade: DotCmsFacade) {}
  ngOnChanges() {
    this.contentlet$ = this.dotCmsFacade.getContentletByIdentifier$(this.identifier());
  }
}
